import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../auth";

export function Layout() {
  const { me, logout } = useAuth();
  const navigate = useNavigate();
  const onLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="bg-slate-900 text-white">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center gap-6">
          <span className="font-semibold">Kepler MCP Portal</span>
          <nav className="flex gap-4 text-sm">
            <Tab to="/">Dashboard</Tab>
            <Tab to="/me/grants">My access</Tab>
            {me?.is_admin && (
              <>
                <Tab to="/admin/users">Account management</Tab>
                <Tab to="/admin/databases">Database management</Tab>
              </>
            )}
          </nav>
          <div className="ml-auto flex items-center gap-3 text-sm">
            {me && (
              <span className="text-slate-300 inline-flex items-center gap-2">
                <span>{me.username}</span>
                {me.is_admin && (
                  <span
                    className="inline-flex items-center gap-1 rounded-full bg-emerald-500/20 text-emerald-300 border border-emerald-400/40 px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide"
                    title="Administrator"
                  >
                    <span aria-hidden>★</span>admin
                  </span>
                )}
              </span>
            )}
            <button
              onClick={onLogout}
              type="button"
              className="inline-flex items-center px-3 py-1.5 rounded text-sm font-medium border border-slate-600 bg-slate-800 text-white hover:bg-slate-700"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 max-w-6xl mx-auto w-full px-4 py-6">
        <Outlet />
      </main>
      <footer className="text-xs text-slate-500 text-center py-3">
        Kepler RDS MCP — admin portal. Surface for analysts is Claude (see runbook).
      </footer>
    </div>
  );
}

function Tab({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `px-1.5 py-1 rounded ${
          isActive ? "text-white border-b-2 border-white" : "text-slate-300 hover:text-white"
        }`
      }
    >
      {children}
    </NavLink>
  );
}
